import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Alert, Typography, Button } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const images = [
  'https://cursos-formacion.camaramadrid.es/wp-content/uploads/2024/10/aula-magna.webp',
  'https://cursos-formacion.camaramadrid.es/wp-content/uploads/2022/05/alquileraulablanca.webp',
  'https://cursos-formacion.camaramadrid.es/wp-content/uploads/2022/04/aula-informatica-2048x1555.webp',
  'https://cursos-formacion.camaramadrid.es/wp-content/uploads/2023/11/aulapolivalente.webp'
];


function BodyCancelar({ refVisita }) {
  const [estado, setEstado] = useState("loading");
  const correoEnviado = React.useRef(false);

const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

const enviarCorreoAdmin = async (peticion) => {
  const fechaFormateada = new Date(peticion.fecha).toLocaleDateString('es-ES');
  const horaFormateada = new Date(peticion.hora).toISOString().slice(11, 16);
  try {
    await fetch('/api/conexionmail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: 'visitascampus@camaramadrid.es', 
        subject: 'El visitante ha cancelado su visita',
        html: `
          <html>
          <body style="margin:0; padding:0; background-color:#f4f4f4; font-family: Arial, sans-serif;">
            <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px 0;">
              <tr>
                <td align="center">
                  <table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px; background-color:#ffffff; border-radius:8px; overflow:hidden;">
                    <tr>
                      <td style="background-color:#f2f2f2; padding:20px; text-align:center;">
                        <img src="https://cursos-formacion.camaramadrid.es/wp-content/themes/cursos-cm/assets/fpyempleo.png"
                             alt="Cámara de Madrid" style="max-width:200px; height:auto;">
                      </td>
                    </tr>
                    <tr>
                      <td style="padding:30px; text-align:center; color:#333333;">
                        <h2 style="margin-top:0; margin-bottom:20px;">Visita cancelada</h2>
                        <p style="font-size:15px; margin:10px 0;">
                          El visitante ha cancelado la siguiente visita:
                        </p>
                        <table style="margin:10px auto; border-collapse:collapse; text-align:left; font-size:14px;">
                          <tr>
                            <td style="padding:3px 7px; font-weight:bold;">👤 Visitante:</td>
                            <td style="padding:3px 7px;">${peticion.nombre} ${peticion.apellidos}</td>
                          </tr>
                          <tr>
                            <td style="padding:3px 7px; font-weight:bold;">📅 Fecha:</td>
                            <td style="padding:3px 7px;">${fechaFormateada}</td>
                          </tr>
                          <tr>
                            <td style="padding:3px 7px; font-weight:bold;">🕒 Hora:</td>
                            <td style="padding:3px 7px;">${horaFormateada}</td>
                          </tr>
                        </table>
                        <p style="margin-top:20px;">
                          Un saludo,<br><br>
                          <strong>Cámara Oficial de Comercio de Madrid</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="background: linear-gradient(to right, #f86254, #b10000); color:#ffffff; padding:15px;">
                        <table width="100%" cellpadding="0" cellspacing="0">
                          <tr>
                            <td style="font-size:13px; text-align:left;">www.camaramadrid.es</td>
                            <td style="font-size:13px; text-align:center;">915 38 35 00</td>
                          </tr>
                          <tr>
                            <td style="font-size:13px; text-align:left; padding-top:8px;">Pedro Salinas 11, Madrid</td>
                            <td style="font-size:13px; text-align:center; padding-top:8px;">camara@camaramadrid.es</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </body>
          </html>
        `
      }),
    });
  } catch (error) {
    console.error('Error enviando correo al admin:', error);
  }
};

  useEffect(() => {
    if (!refVisita) return;

    setEstado("loading");

    fetch('/api/anularvisita', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ref: refVisita })
    })
      .then(res => res.json())
      .then(data => {
        console.log("Respuesta del servidor:", data);
        if (data.success) {
          setEstado('success');
          if (!correoEnviado.current) {
            correoEnviado.current = true;
            enviarCorreoAdmin(data.peticion);
          }
        }
        else if (data.expired) setEstado('expired');
        else if (data.alreadyCancelled) setEstado('already');
        else setEstado('error');
      })
      .catch(() => setEstado('error'));
  }, [refVisita]);

  const Image = (
    <Box flex={1} display="flex" justifyContent="center" alignItems="center">
      <img
        src="https://www.camaramadrid.es/documents/20182/40518471/2025.10.03+NW++NW+campus+C%C3%A1mara.jpg/f61f2b7b-0e6f-468c-a3a3-82cbe14d7a06?t=1759485062087"
        alt="Cámara de Madrid"
        style={{
          width: "100%",
          maxWidth: "420px",
          borderRadius: "10px",
          objectFit: "cover",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.15)"
        }}
      />
    </Box>
  );

  const TextBlock = (title, text, button) => {
  const handleClick = () => {
    if (button.reload) {
      window.location.reload();
    } else if (button.link) {
      window.open(button.link, "_blank");
    }
  };

  return (
    <Box flex={1} display="flex" flexDirection="column" gap={2}>
      <Alert
        variant="filled"
        severity={button.severity}
        sx={{ width: "100%", textAlign: "center", justifyContent: "center" }}
      >
        {title}
      </Alert>
      <hr style={{ width: "100%", border: "0.5px solid #ddd" }} />
      <Typography sx={{ fontSize: "18px", color: "#444", lineHeight: 1.7 }}>
        {text}
      </Typography>
      <hr style={{ width: "100%", border: "0.5px solid #ddd" }} />
      <Box display="flex" justifyContent="center">
        <Button variant="outlined" color={button.severity} onClick={handleClick}>
          {button.label}
        </Button>
      </Box>
    </Box>
  );
};

  const renderContent = () => {
    switch (estado) {
      case "success":
        return (
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>
            {TextBlock(
              "VISITA CANCELADA CORRECTAMENTE",
              "La visita ha sido cancelada correctamente. Si quiere agendar otra visita puede acceder en el siguiente enlace.",
              { label: "Agendar nueva cita", severity: "success", link: `https://gestiondevisitas.camaramadrid.es/external/${refVisita}` }
            )}
            {Image}
          </Box>
        );
      case "already":
        return (
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>
            {TextBlock(
              "VISITA YA CANCELADA",
              "Esta visita ya ha sido cancelada previamente. Acceda al siguiente enlace si quiere agendar otra visita.",
              { label: "Agendar nueva cita", severity: "info", link: `https://gestiondevisitas.camaramadrid.es/external/${refVisita}` }
            )}
            {Image}
          </Box>
        );
      case "expired":
        return (
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>
            {TextBlock(
              "VISITA EXPIRADA",
              "La fecha de esta visita ha expirado. Si estás interesado, puedes solicitar una nueva fecha para poder conocer nuestras instalaciones.",
              { label: "Solicitar nueva fecha", severity: "warning", link: `https://gestiondevisitas.camaramadrid.es/external/${refVisita}` }
            )}
            {Image}
          </Box>
        );
      case "error":
        return (
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={3}>
            {TextBlock(
              "ERROR DE COMUNICACIÓN",
              "Ha ocurrido un problema al procesar la solicitud. Por favor, inténtalo de nuevo más tarde.",
              { label: "Reintentar", severity: "error", reload: true }
            )}
            {Image}
          </Box>
        );
      default:
        return (
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <CircularProgress />
            <p>Cancelando visita...</p>
          </Box>
        );
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100%" bgcolor="#f5f5f5" p={1}>
      <Box width="85%" boxShadow={3} borderRadius={3} bgcolor="#fff" p={4}>
        {renderContent()}
      </Box>
    </Box>
  );
}

export default BodyCancelar;